import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import { CLASSNAME_PREFIXES } from '../../constants/classname_prefixes.js';
import { useTranslations } from '../../hooks/use_translations.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { avatarSizeToPixelsMap } from '../AvatarUser/AvatarUser.js';
import { Circle } from '../Circle/Circle.js';
import { IconUserGroup } from '../Icons/IconUserGroup.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["className", "size"];
var AvatarTeam = function AvatarTeam(props) {
  var className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? "md" : _props$size,
    rest = _objectWithoutProperties(props, _excluded);
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  var iconSize = avatarSizeToPixelsMap[size].iconSize;
  return /*#__PURE__*/jsx(Circle, _objectSpread(_objectSpread({
    className: classNames(CLASSNAME_PREFIXES.AVATAR_TEAM, className),
    size: size,
    "aria-label": t("AvatarTeam.avatarLabel")
  }, rest), {}, {
    children: /*#__PURE__*/jsx(IconUserGroup, {
      title: t("AvatarTeam.avatarLabel"),
      role: "img",
      "aria-hidden": false,
      focusable: true,
      height: iconSize,
      width: iconSize
    })
  }));
};
AvatarTeam.displayName = "AvatarTeam";

export { AvatarTeam };
